import { useCallback } from 'react';
import { format } from 'date-fns';
import { exportApi } from '../../../api/export';
import { useAlert } from '../../../contexts/AlertContext';
import { LeaderboardTab } from '../types';

export const useExport = () => {
  const { showAlert } = useAlert();

  const downloadFile = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const handleExport = useCallback(
    async (
      activeTab: LeaderboardTab,
      eventId: number | undefined,
      search: string,
      startDate: Date | null,
      endDate: Date | null
    ) => {
      try {
        if (!eventId) return;

        const params = {
          dateFrom: startDate ? format(startDate, 'yyyy-MM-dd') : undefined,
          dateTo: endDate ? format(endDate, 'yyyy-MM-dd') : undefined,
          userName: activeTab === 'participants' ? search?.trim() || undefined : undefined,
          districtName: activeTab === 'areas' ? search?.trim() || undefined : undefined,
          officeName: activeTab === 'offices' ? search?.trim() || undefined : undefined,
        };

        let result: { blob: Blob; filename: string };

        if (activeTab === 'participants') {
          result = await exportApi.participants(eventId, params);
        } else if (activeTab === 'areas') {
          result = await exportApi.districts(eventId, params);
        } else if (activeTab === 'offices') {
          result = await exportApi.offices(eventId, params);
        } else {
          return;
        }

        downloadFile(result.blob, result.filename);
        showAlert('Export completed successfully', 'success');
      } catch (error) {
        showAlert('Failed to export data', 'error');
      }
    },
    [showAlert]
  );

  return { handleExport };
};
